import { useTranslation } from 'react-i18next';
import CheckboxTree from 'components/CheckboxTree/CheckboxTree';

import HeaderFilterPanel from './HeaderFilterPanel';

import type IFilterListOrgStructure from '../interfaces/IFilterListOrgStructure';

import styles from '../sass/FiltersPanel.module.scss';

function FilterListOrgStructure({
  items,
  selectedLeafIds,
  onChangeSelectedLeafIds,
  onBackStepFilter,
  onResetAllCurrent,
}: IFilterListOrgStructure) {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <HeaderFilterPanel
        selectedFilter={t('common.organizationalStructure')}
        onBackStepFilter={onBackStepFilter}
        onResetAllCurrent={onResetAllCurrent}
        ghostButtonTitle={t('common.reset')}
      />
      <div className={styles.filters}>
        <CheckboxTree
          items={items}
          selectedLeafIds={selectedLeafIds}
          onChangeSelectedLeafIds={onChangeSelectedLeafIds}
          className={styles.orgStructureTree}
        />
      </div>
    </div>
  );
}

export default FilterListOrgStructure;
